var modules_92ddc69a = {"text":"_1fyv24t","container":"_9skbzd"};
import "../../../assets/D0vcsmiV.css";

export { modules_92ddc69a as default };
//# sourceMappingURL=UIState.module.less.js.map
